import { FileInfoProcessingRuns } from "../FileInfoProcessingRuns/FileInfoProcessingRuns"
import { CloseIcon } from "components/ui/icons/close/CloseIcon"
import { H2 } from "components/ui/typography/titles/Titles"
import { BandgeStatus } from "components/ui/bandges/BadgeStatus/BadgeStatus"
import { Skeleton } from "antd"
import type { TBadge } from "types/badges.type"
import style from "./Header.module.scss"

const { header, status, statusAndRuns, drawingStatusStyle, title, closeButton, closeIcon } = style

type Props = {
	onCloseDrawer: () => void
	finalDrawingStatus: TBadge
	drawingName: string
	isDrawingPending: boolean
}

export const Header = ({ onCloseDrawer, finalDrawingStatus, drawingName, isDrawingPending }: Props) => {
	return (
		<div className={header}>
			<div className={status}>
				<div className={statusAndRuns}>
					<div className={drawingStatusStyle}>
						{isDrawingPending ? <Skeleton.Button active size="small" /> : <BandgeStatus type={finalDrawingStatus} />}
					</div>
					{!isDrawingPending && finalDrawingStatus !== "uploaded" ? <FileInfoProcessingRuns /> : null}
				</div>
				<button className={closeButton} onClick={onCloseDrawer}>
					<CloseIcon className={closeIcon} />
				</button>
			</div>
			<H2 className={title}>{isDrawingPending ? <Skeleton.Input active size="small" /> : drawingName}</H2>
		</div>
	)
}
